import { render, staticRenderFns } from "./ExternalUserProfile.vue?vue&type=template&id=20a03e1f&scoped=true&"
import script from "./ExternalUserProfile.vue?vue&type=script&lang=js&"
export * from "./ExternalUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./ExternalUserProfile.vue?vue&type=style&index=0&id=20a03e1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a03e1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20a03e1f')) {
      api.createRecord('20a03e1f', component.options)
    } else {
      api.reload('20a03e1f', component.options)
    }
    module.hot.accept("./ExternalUserProfile.vue?vue&type=template&id=20a03e1f&scoped=true&", function () {
      api.rerender('20a03e1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ExternalUserProfile.vue"
export default component.exports